import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Benefit,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogBenefitCard';
export type SPCatalogBenefitCardLocNames = `${LocNameStart}Change`;

export const spCatalogBenefitCardLocs: LocDefs<SPCatalogBenefitCardLocNames> = {
	SPCatalogBenefitCardChange: {
		defaultValue: 'Change',
		description: 'Button to change the benefit and navigate to the list of benefits.',
		displayPath: `${pathStart}Change Button`,
		displayType: 'Button',
		legacyName: 'Benefit/Catalogs.BenefitsNavCard.Button.Change',
		...sharedProperties,
	},
};

export type SPCatalogBenefitLocType = LocMap<SPCatalogBenefitCardLocNames>;
